import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UserCountByAdminState } from '@modules/administration/models/user-count-by-admin-state';
import { ActionButtonsComponent } from '@modules/shared/action-buttons/action-buttons.component';
import { TuiTitle } from '@taiga-ui/core';
import { TuiBadge } from '@taiga-ui/kit';
import { ActionButton } from 'src/app/shared/models/menu-actions/action-buttons';
import { MenuAction } from 'src/app/shared/models/menu-actions/menu-action';
import { UserStateCountComponent } from '../user-state-count/user-state-count.component';

@Component({
  selector: 'pxc-administration-table-header',
  imports: [TuiTitle, TuiBadge, UserStateCountComponent, ActionButtonsComponent],
  templateUrl: './administration-table-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-wrap items-center justify-between gap-2 border-b border-border-normal px-3 py-4',
  },
})
export class AdministrationTableHeaderComponent {
  @Input() title: string;
  @Input() counterLabel: string;
  @Input() userCountByAdminState: UserCountByAdminState;
  @Input() actions: MenuAction[];
  @Input() actionButtonsGroups: ActionButton[];
}
